import React, { useEffect, useState } from "react";
import { Button, Radio, Typography } from "antd";
const { Text } = Typography;

const upiApps = [
  {
    id: "gpay",
    name: "Google Pay",
    scheme: "tez://upi/pay",
    icon: "/icons/gpay.svg",
  },
  {
    id: "phonepe",
    name: "PhonePe",
    scheme: "phonepe://upi/pay",
    icon: "/icons/phonepe.svg",
  },
  {
    id: "paytm",
    name: "Paytm",
    scheme: "paytmmp://upi/pay",
    icon: "/icons/paytm.svg",
  },
  {
    id: "cred",
    name: "CRED",
    scheme: "cred://upi/pay",
    icon: "/icons/cred.svg",
  },
];

export default function PaymentApps() {
  const [availableApps, setAvailableApps] = useState([]);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    // detect available apps
    const detectApps = async () => {
      const results = [];
      for (const app of upiApps) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = app.scheme;
        document.body.appendChild(iframe);

        let opened = false;
        const start = Date.now();
        try {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          if (Date.now() - start < 1200) opened = true;
        } catch {}
        document.body.removeChild(iframe);
        if (opened) results.push(app);
      }
      setAvailableApps(results.length ? results : upiApps);
    };
    detectApps();
  }, []);

  const handlePayment = () => {
    // const upiIntent =
    //   "upi://pay?pa=escrow@nsdlpbma&pn=Khazana&am=1.00&cu=INR&tr=TEST123";
    const upiIntent =
      "upi://pay?pa=escrow@nsdlpbma&pn=&mc=6012&tr=531085229175996963&tn=PCMZRNKI8T&am=1.00&cu=INR&mode=04&tid=NPT00000000000000531085229175996963";

    window.location.href = upiIntent;
  };

  return (
    <div style={{ padding: 20 }}>
      <Text>Select UPI App</Text>
      <Radio.Group
        onChange={(e) => setSelected(e.target.value)}
        value={selected}
        style={{ display: "block", marginTop: 10 }}
      >
        {availableApps.map((app) => (
          <div
            key={app.id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img src={app.icon} alt={app.name} width={28} />
              <Text>{app.name}</Text>
            </div>
            <Radio value={app.id} />
          </div>
        ))}
      </Radio.Group>

      <Button
        type="primary"
        block
        size="large"
        style={{ marginTop: 20 }}
        onClick={handlePayment}
      >
        Pay Now
      </Button>
    </div>
  );
}
